import { AiTwotonePhone } from 'react-icons/ai'; 
import { FaEnvelope } from 'react-icons/fa';
import { BsLinkedin, BsGithub } from 'react-icons/bs';


const contacts = [
    {
        id: 1,
        icon: <AiTwotonePhone />,
        title: 'Phone:',
        content: ['+123-456-789', '+111-222-333'],
    },
    {
        id: 2,
        icon: <FaEnvelope />,
        title: 'email:',
        content: ['abc@gmail.com', 'xyz@gmail.com'],
    },
    {
        id: 3,
        icon: <BsLinkedin />,
        title: 'linkedin:',
        content: ['https://www.linkedin.com/'],
    },
    {
        id: 4,
        icon: <BsGithub />,
        title: 'github:',
        content: ['https://github.com/'],
    },
 
];

export default contacts;